import * as React from "react";
import Modal from "@material-ui/core/Modal";
import { Col, Button, Row, Table } from "reactstrap";
import AlertModal from "../../../../shared/components/Modal";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import Spinner from "react-bootstrap/Spinner";
import Select from "@material-ui/core/Select";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faRadiation } from "@fortawesome/free-solid-svg-icons";
import {
  KeyboardDateTimePicker,
  MuiPickersUtilsProvider,
} from "@material-ui/pickers";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormLabel from "@material-ui/core/FormLabel";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import InputAdornment from "@material-ui/core/InputAdornment";
import {
  createMuiTheme,
  makeStyles,
  ThemeProvider,
} from "@material-ui/core/styles";
import MomentUtils from "@date-io/moment";
import moment from "moment";
import { useState, useEffect, Fragment } from "react";
import { ConsoleView } from "react-device-detect";
import { error } from "jquery";
import InfoPatient from "../../../ClinicHistory/SearchClinicHistory/components/InfoPatient";
import RadiopharmacyDataReactTable from "./RadiopharmacyAdmisionTable";
import { useMemo } from "react";

const theme = createMuiTheme({
  palette: {
    primary: {
      light: "#84ffe7",
      main: "#49e0b5",
      dark: "#00ad85",
      contrastText: "#fff",
      height: "10px",
    },
  },
});
const useStyles = makeStyles((theme) => ({
  root: {
    height: 35,
    justifyContent: "start",
    display: "inline",
  },
  group: {
    display: "inline !important",
  },
}));
const MedicineAdmision = ({
  data,
  closeMedicineAdmision,
  opened,
  radioPharmacy,
  loadRadioPharmacy,
  callbackRadioPharmacy,
  callbackupdateCanalization,
  radiofarmacos,
}) => {
  //Atributos
  const [isLoading, setIsLoading] = useState(false);

  //Datos
  const [nombrePaciente, setNombrePaciente] = useState(data.original.fullname);
  const [numPaciente, setNumPaciente] = useState(data.original.num_documento);
  const [nameRadioPharmacy, setNameRadioPharmacy] = useState(null);
  const [unit, setUnit] = useState("");
  const [fechaAplicacion, setFechaAplicacion] = useState(new Date());
  const [aplicacionFarmaco, setAplicacionFarmaco] = useState(false);
  const [dosis, setDosis] = useState("");
  const [observacion, setObservacion] = useState("");
  const [medService, setMedService] = useState(null);
  const [unitsMearurement, setUnitsMearurement] = useState([]);
  const [idUnitMeasurement, setIdUnitMeasurement] = useState(null);
  const [medicines, setMedicines] = useState([]);
  const [medicinesToDisplay, setMedicinesToDisplay] = useState([]);
  const [canalizationNeeded, setCanalizationNeeded] = useState({
    id_perfil: null,
    answer: null,
    name: null,
    date: new Date(),
    body_part: null,
  });
  const [errors, setErrors] = useState({});
  const [age, setAge] = useState("");
  const [showMoreServices, setShowMoreServices] = useState(false);
  const userProfile = sessionStorage.getItem("perfil");
  const [disabledFormCanalization, setDisabledFormCanalization] =
    useState(false);

  //Alerta
  const [showAlertModal, setAlerShowModal] = useState(false);
  const [messagAlerteModal, setAlertMessageModal] = useState(null);
  const [colorAlertModal, setAlertColorModal] = useState("");

  const validateGamagrafia = () => {
    let arrayMedicinesToDisplay = [];
    try {
      let existeGamagrafia = data.original.servicios.some(
        (ser) =>
          ser.nombre.toUpperCase().search("GAMAGRAFIA") != -1 ||
          ser.codigo.substr(0, 2) == "92"
      );

      if (existeGamagrafia) {
        medicines.map((med) => {
          let nameMed = med.nom_articulo;
          arrayMedicinesToDisplay.push({
            nameMed: nameMed,
            nom_articulo: nameMed,
            unidad_medida: med.unidad_medida,
          });
        });
      } else {
        medicines.map((med) => {
          let nameMed = med.nom_articulo;
          let unit = unitsMearurement.find(
            (unit) => unit.codigo === med.unidad_medida
          );
          arrayMedicinesToDisplay.push({
            nameMed: med.nom_articulo + " " + unit.nombre,
            nom_articulo: nameMed,
            unidad_medida: med.unidad_medida,
          });
        });
      }
      setMedicinesToDisplay(arrayMedicinesToDisplay);
      console.log("ItemsToDisplay", arrayMedicinesToDisplay);
    } catch (e) {
      console.log("errorGamagrafia", e);
    }
  };

  const validate = (values) => {
    const errors = {};

    if (
      typeof canalizationNeeded.body_part === "object" ||
      canalizationNeeded.body_part == ""
    ) {
      errors.body_part = "Seleccione una parte del cuerpo a canalizar";
    }
    return errors;
  };

  useEffect(() => {
    validateCanalization();
    validateGamagrafia();
    calculateAge(data.original.birthday);
  }, [medicines, unitsMearurement]);

  useEffect(() => {
    const loadUnitsMeasurement = async () => {
      await fetch(
        process.env.REACT_APP_PUBLIC_URL +
          "medicamento-stock/listar-unidad-medida",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Error en el servidor");
          }
        })
        .then((data) => {
          setUnitsMearurement(data);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    loadUnitsMeasurement();

    const loadMedicines = async () => {
      await fetch(
        process.env.REACT_APP_PUBLIC_URL + "medicamento-stock/listar",
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            authorization: "Bearer " + sessionStorage.getItem("token"),
          },
        }
      )
        .then((response) => {
          if (response.status != 500 && response.status != 403) {
            return response.json();
          } else {
            throw new Error("Error en el servidor");
          }
        })
        .then((data) => {
          setMedicines(data);
        })
        .catch((error) => {
          console.log(error);
        });
    };

    loadMedicines();
  }, []);

  const chargeIdUnitMedicine = (nameMedicine) => {
    let medicine = medicinesToDisplay.find(
      (med) => med.nameMed.toUpperCase() == nameMedicine.toUpperCase()
    );
    if (medicine != null && medicine != undefined) {
      setIdUnitMeasurement(medicine.unidad_medida);
    }
  };

  const onOkModal = () => {
    switch (colorAlertModal) {
      case "success":
        setAlerShowModal(false);
        break;
      case "success-canalization":
        setAlerShowModal(true);
        break;
      case "warning":
        aplicarRadioFarmaco();
        canalizationApplied();
        break;
      case "danger":
        setAlerShowModal(true);
        closeMedicineAdmision(false);
        break;
    }
  };

  const validateCanalization = () => {
    if (data.original.canalizacion_radiofarmaco !== null) {
      setCanalizationNeeded({
        ...canalizationNeeded,
        answer: data.original.canalizacion_radiofarmaco.answer,
        body_part: data.original.canalizacion_radiofarmaco.body_part,
        date: data.original.canalizacion_radiofarmaco.date,
        name: data.original.canalizacion_radiofarmaco.name,
        id_perfil: data.original.canalizacion_radiofarmaco.id_perfil,
      });
    }
    if (
      radioPharmacy !== null &&
      data.original.canalizacion_radiofarmaco == null
    ) {
      setCanalizationNeeded({ ...canalizationNeeded, answer: "NO" });
    }
  };
  const handlerCanalization = (e) => {
    var user = sessionStorage.getItem("usuario");
    user = JSON.parse(user);
    let nombre = user.nombre;
    let id_perfil = user.id_perfil;
    setCanalizationNeeded((prevState) => {
      return { ...prevState, answer: e.target.value };
    });
    setCanalizationNeeded((prevState) => {
      return { ...prevState, id_perfil: id_perfil };
    });
    setCanalizationNeeded((prevState) => {
      return { ...prevState, name: nombre };
    });
    if (e.target.value === "NO") {
      setCanalizationNeeded((prevState) => {
        return { ...prevState, date: new Date() };
      });
      setCanalizationNeeded((prevState) => {
        return { ...prevState, body_part: null };
      });
    }
  };
  const handlerDateCanalization = (date) => {
    setCanalizationNeeded((prevState) => {
      return { ...prevState, date: date };
    });
  };

  const handlerPartBodyCanalized = (e) => {
    setCanalizationNeeded((prevState) => {
      return { ...prevState, body_part: e.target.value };
    });
  };

  const canalizationApplied = async () => {
    if (canalizationNeeded.answer == "SI") {
      if (
        canalizationNeeded.body_part == null &&
        canalizationNeeded.body_part == undefined &&
        canalizationNeeded.body_part == ""
      ) {
        alert("Debe seleccionar una opción de canalización");
        return;
      }

      let dataSend = {
        id_admision: data.original.id_admision,
        canalizacion: {
          id_perfil: canalizationNeeded.id_perfil,
          answer: canalizationNeeded.answer,
          name: canalizationNeeded.name,
          date: moment(canalizationNeeded.date).format("yyyy-MM-DD HH:mm:ss"),
          body_part: canalizationNeeded.body_part,
        },
      };

      let errors = validate(dataSend);
      setErrors(errors);
      console.log(JSON.stringify(errors));

      if (Object.entries(errors).length === 0) {
        console.log("DATASENDRADIO", dataSend);
        await fetch(
          process.env.REACT_APP_PUBLIC_URL +
            "admision/canalizacion-radiofarmaco",
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              authorization: "Bearer " + sessionStorage.getItem("token"),
            },
            body: JSON.stringify(dataSend),
          }
        )
          .then((response) => {
            if (response.status != 500 && response.status != 403) {
              setAlertColorModal("success");
              //alertModal(true, "Canalización registrada correctamente");
              setAlertMessageModal("Canalización registrada correctamente");
              setAlerShowModal(true);
              setDisabledFormCanalization(true);
              /* callbackupdateCanalization(
                data.original.id_admision,
                dataSend.canalizacion
              ); */
            } else {
              throw new Error("Error en el servidor");
            }
          })
          .catch((err) => {
            console.log(err);
            setAlerShowModal("danger");
          });
      }
    }
  };
  const aplicarRadioFarmaco = async () => {
    var user = sessionStorage.getItem("usuario");
    user = JSON.parse(user);
    if (canalizationNeeded.answer == null) {
      alert("Debe seleccionar una opción de canalización");
      return;
    }
    if (nameRadioPharmacy == null || nameRadioPharmacy == "") {
      alert("Debe seleccionar el nombre del Radiofarmaco");
      return;
    }

    if (unit == "") {
      alert("Debe seleccionar la unidad de medida del Radiofarmaco");
      return;
    }
    if (dosis == null || dosis == "") {
      alert("Debe escribir la cantidad del Radiofarmaco");
      return;
    }

    let dataSend = {
      fecha_aplicacion: moment(fechaAplicacion).format("yyyy-MM-DD HH:mm:ss"),
      id_paciente: data.original.id_paciente,
      id_admision: data.original.id_admision,
      nombre_medicamento: nameRadioPharmacy + " " + unit,
      observacion: observacion,
      dosis: dosis + " " + unit,
      codigo_medida: idUnitMeasurement,
      id_perfil: user.id_perfil,
      canalizacion: canalizationNeeded,
    };
    console.log("DATASENDRADIO", dataSend);
    await fetch(
      process.env.REACT_APP_PUBLIC_URL + "admision-radiofarmaco/create",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: "Bearer " + sessionStorage.getItem("token"),
        },
        body: JSON.stringify(dataSend),
      }
    )
      .then((response) => {
        if (response.status != 500 && response.status != 403) {
          setAlerShowModal(true);
          setAlertColorModal("success");
          setAlertMessageModal("Radiofármaco registrada correctamente");
          loadRadioPharmacy();
          setNameRadioPharmacy(null);
          setAplicacionFarmaco(false);
          setUnit("");
          setDosis("");
          setObservacion("");
          //callbackRadioPharmacy(data.original.id_admision, true);
        } else {
          throw new Error("Error en el servidor");
        }
      })
      .catch((err) => {
        console.log(err);
        setAlerShowModal("danger");
      });
  };

  const calculateAge = (birthday) => {
    let hoy = new Date();
    let cumpleanos = new Date(birthday);
    let edad = hoy.getFullYear() - cumpleanos.getFullYear();
    let meses = hoy.getMonth() - cumpleanos.getMonth();

    if (meses < 0 || (meses === 0 && hoy.getDate() < cumpleanos.getDate())) {
      edad--;
    }
    let cantMeses = meses;

    if (meses < 0) {
      cantMeses = 12 + meses;
    }

    let edadTotal = edad + " años ";
    let fecha = moment(birthday, "YYYYMMDD").fromNow(true);

    setAge(edadTotal);
  };
  const classes = useStyles();

  let reactTableData = useMemo(() => {
    return {
      tableHeaderData: [
        {
          Header: "Nombre del medicamento",
          accessor: "nombre_medicamento",
        },
        {
          Header: "Dosis",
          accessor: "dosis",
        },
        {
          Header: "Fecha de aplicacion",
          accessor: "fecha_aplicacion",
          Cell: (row) => (
            <p>{moment(row.value).format("YYYY-MM-DD HH:mm:ss")}</p>
          ),
        },
        {
          Header: "Observacion",
          accessor: "observacion",
        },
      ],
      tableRowsData: radioPharmacy,
    };
  }, [radioPharmacy]);

  return (
    <div>
      <Modal
        open={opened}
        onClose={(e) => {
          closeMedicineAdmision(false);
        }}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ zIndex: 1000 }}
      >
        <div
          className="paperAppointment-flex"
          style={{ width: "100%", margin: 10 }}
        >
          <div>
            <div className="card__title">
              <h5 className="bold-text">
                <FontAwesomeIcon
                  style={{ fontSize: "25px" }}
                  icon={faRadiation}
                />
                Aplicación de Radiofarmaco
              </h5>
            </div>
            <InfoPatient dataPatient={data.original} />
            {radiofarmacos.length > 0 ? (
              <Fragment>
                <h5>Aplicaciones de Medicamentos previas</h5>
                <Table
                  responsive
                  borderless
                  size="sm"
                  style={{ width: "100%", marginTop: ".25em" }}
                >
                  <thead>
                    <tr>
                      <td>NOMBRE DEL MEDICAMENTO </td>
                      <td>DOSIS </td>
                      <td>FECHA DE APLICACIÓN </td>
                      <td>OBSERVACIONES </td>
                    </tr>
                  </thead>
                  <tbody>
                    {radiofarmacos.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td>{data.nombre_medicamento}</td>
                          <td>{data.dosis}</td>
                          <td>
                            {moment(data.fecha_aplicacion).format("DD/MM/YYYY")}
                          </td>
                          <td>{data.observacion}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Fragment>
            ) : null}
            <Row>
              {isLoading == false ? (
                <div>
                  <Row style={{ marginTop: 30 }}>
                    <Col>
                      <ThemeProvider theme={theme}>
                        {/* <FormControl component="fieldset" className={classes.root} style={{ display: 'flex', flexDirection: 'row', marginLeft: 15 }}>
                                                        <FormLabel component="legend" style={{ width: 230, marginTop: 14 }}>¿Se requiere canalización?</FormLabel>
                                                        <RadioGroup
                                                            aria-label="rigth_patient"
                                                            name="radio2"
                                                            value={canalizationNeeded.answer}
                                                            style={{ display: 'inline' }}
                                                            onChange={e => handlerCanalization(e)}
                                                            className={classes.group}
                                                        >
                                                            <FormControlLabel value="SI" control={<Radio color="primary" disabled={radioPharmacy == null ? false : true} />} label="SI" />
                                                            <FormControlLabel value="NO" control={<Radio color="primary" disabled={radioPharmacy == null ? false : true} />} label="NO" />
                                                        </RadioGroup>
                                                    </FormControl> */}
                        <FormControl component="fieldset">
                          <FormLabel
                            component="legend"
                            style={{ flexDirection: "row" }}
                          >
                            ¿Se requiere canalización?
                          </FormLabel>
                          <RadioGroup
                            aria-label="canalization"
                            name="canalization1"
                            style={{ flexDirection: "row" }}
                            value={canalizationNeeded.answer}
                            onChange={(e) => handlerCanalization(e)}
                          >
                            <FormControlLabel
                              value="SI"
                              control={
                                <Radio
                                  color="primary"
                                  disabled={
                                    data.original.canalizacion_radiofarmaco !==
                                      null ||
                                    userProfile == 10 ||
                                    disabledFormCanalization
                                      ? true
                                      : false
                                  }
                                />
                              }
                              label="SI"
                            />
                            <FormControlLabel
                              value="NO"
                              control={
                                <Radio
                                  color="primary"
                                  disabled={
                                    data.original.canalizacion_radiofarmaco !==
                                      null ||
                                    userProfile == 10 ||
                                    disabledFormCanalization
                                      ? true
                                      : false
                                  }
                                />
                              }
                              label="NO"
                            />
                          </RadioGroup>
                        </FormControl>
                      </ThemeProvider>
                    </Col>
                    {canalizationNeeded.answer === "SI" ? (
                      <React.Fragment>
                        <Col>
                          <MuiPickersUtilsProvider utils={MomentUtils}>
                            <KeyboardDateTimePicker
                              value={canalizationNeeded.date}
                              disabled={true}
                              onChange={(date) => handlerDateCanalization(date)}
                              label="Fecha y Hora de la canalización"
                              format="yyyy-MM-DD HH:mm:ss"
                              animateYearScrolling
                              className="medical-material-form__field material-form__label"
                              style={{
                                minWidth: "250px",
                                maxWidth: "100%",
                                marginTop: 5,
                              }}
                              InputLabelProps={{
                                style: { color: "#646777" },
                              }}
                            />
                          </MuiPickersUtilsProvider>
                        </Col>
                        <Col>
                          <FormControl
                            className="medical-material-form__field"
                            InputLabelProps={{
                              style: { color: "#646777" },
                              shrink: true,
                            }}
                            style={{ width: "100%", marginTop: 5 }}
                            error={
                              errors.hasOwnProperty("body_part")
                                ? errors.body_part !== ""
                                : false
                            }
                          >
                            <InputLabel
                              shrink={true}
                              id="body_part-simple-select-label"
                            >
                              Sitio de Canalización
                            </InputLabel>
                            <Select
                              labelId="body_part_canalized-simple-select-label"
                              id="body_part_canalized-simple-select"
                              value={canalizationNeeded.body_part}
                              onChange={(event) => {
                                handlerPartBodyCanalized(event);
                              }}
                              disabled={
                                data.original.canalizacion_radiofarmaco !==
                                  null ||
                                userProfile == 10 ||
                                disabledFormCanalization
                                  ? true
                                  : false
                              }
                              error={
                                errors.hasOwnProperty("body_part")
                                  ? errors.body_part !== ""
                                  : false
                              }
                            >
                              {data.original.canalizacion_radiofarmaco &&
                                [
                                  { value: 1, label: "DORSO DE LA MANO" },
                                  { value: 2, label: "ANTEBRAZO" },
                                  { value: 3, label: "BRAZO" },
                                  { value: 4, label: "CUELLO" },
                                  { value: 5, label: "PIERNA" },
                                ].map((option) => (
                                  <MenuItem
                                    key={option.value}
                                    value={option.value}
                                  >
                                    {option.label}
                                  </MenuItem>
                                ))}

                              <MenuItem value={6}>
                                DORSO DE LA MANO IZQUIERDA{" "}
                              </MenuItem>
                              <MenuItem value={7}>
                                DORSO DE LA MANO DERECHA{" "}
                              </MenuItem>
                              <MenuItem value={8}>
                                ANTEBRAZO IZQUIERDA{" "}
                              </MenuItem>
                              <MenuItem value={9}>ANTEBRAZO DERECHA </MenuItem>
                              <MenuItem value={10}>BRAZO IZQUIERDA</MenuItem>
                              <MenuItem value={11}>BRAZO DERECHA</MenuItem>
                              <MenuItem value={12}>CUELLO</MenuItem>
                              <MenuItem value={13}>PIERNA IZQUIERDA</MenuItem>
                              <MenuItem value={14}>PIERNA DERECHA</MenuItem>
                            </Select>
                            <FormHelperText>{errors.body_part}</FormHelperText>
                          </FormControl>
                        </Col>
                      </React.Fragment>
                    ) : null}
                  </Row>
                  {canalizationNeeded.answer !== null ? (
                    <>
                      <Row style={{ marginTop: 10 }}>
                        <Col md={6}>
                          <TextField
                            required
                            select
                            id="txtNombreRadioFarmaco"
                            label="Nombre Radiofarmaco"
                            value={nameRadioPharmacy}
                            onChange={(e) => {
                              setNameRadioPharmacy(e.target.value);
                              chargeIdUnitMedicine(e.target.value);
                            }}
                            className="medical-material-form__field"
                            InputLabelProps={{
                              style: { color: "#646777" },
                            }}
                            style={{ minWidth: "300px", maxWidth: "100%" }}
                          >
                            {/* {data.original.servicios[0].medicamentos.length ?
                                                        data.original.servicios[0].medicamentos.map((medicamento) => (
                                                            <MenuItem key={medicamento.cod_medicamento} value={medicamento.nom_articulo}>
                                                                {medicamento.nom_articulo}
                                                            </MenuItem>
                                                        )
                                                        ) :
                                                        medicines.map((medicine) => (
                                                            <MenuItem key={medicine.cod_medicamento} value={medicine.nom_articulo}>
                                                                {medicine.nom_articulo}
                                                            </MenuItem>
                                                        ))
                                                    } */}

                            {medicinesToDisplay !== null
                              ? medicinesToDisplay.map((med, index) => (
                                  <MenuItem key={index} value={med.nameMed}>
                                    {med.nameMed}
                                  </MenuItem>
                                ))
                              : medicines.map((medicine) => (
                                  <MenuItem
                                    key={medicine.cod_medicamento}
                                    value={medicine.nom_articulo}
                                  >
                                    {medicine.nom_articulo}
                                  </MenuItem>
                                ))}
                          </TextField>
                        </Col>
                        <Col md={6}>
                          <TextField
                            required
                            select
                            id="txtUnidadMedida"
                            label="Unidad de medida"
                            value={unit}
                            onChange={(e) => {
                              setUnit(e.target.value);
                            }}
                            className="medical-material-form__field"
                            InputLabelProps={{
                              style: { color: "#646777" },
                            }}
                            style={{ minWidth: "300px", maxWidth: "100%" }}
                          >
                            {unitsMearurement.map((medUnit) => {
                              return (
                                <MenuItem
                                  key={medUnit.codigo}
                                  value={medUnit.nombre}
                                >
                                  {medUnit.nombre}
                                </MenuItem>
                              );
                            })}
                          </TextField>
                        </Col>
                      </Row>
                      <Row md={12}>
                        {aplicacionFarmaco !== false ? (
                          <Col>
                            <MuiPickersUtilsProvider utils={MomentUtils}>
                              <KeyboardDateTimePicker
                                value={fechaAplicacion}
                                disabled={true}
                                onChange={(date) => setFechaAplicacion(date)}
                                label="Fecha y Hora de Aplicación del Farmaco"
                                format="yyyy-MM-DD HH:mm:ss"
                                animateYearScrolling
                                className="medical-material-form__field material-form__label"
                                style={{
                                  minWidth: "300px",
                                  maxWidth: "100%",
                                  marginTop: 5,
                                }}
                                InputLabelProps={{
                                  style: { color: "#646777" },
                                }}
                              />
                            </MuiPickersUtilsProvider>
                          </Col>
                        ) : null}
                        <Col>
                          <TextField
                            id="select_aplicado"
                            select
                            label="Aplicación del Farmaco"
                            value={aplicacionFarmaco}
                            className="medical-material-form__field"
                            onChange={(event) => {
                              setAplicacionFarmaco(event.target.value);
                              if (event.target.value === false) {
                                setFechaAplicacion(new Date());
                              }
                            }}
                            style={{ borderColor: "black", marginTop: 5 }}
                            InputLabelProps={{
                              style: { color: "#646777" },
                            }}
                          >
                            <MenuItem key={1} value={false}>
                              {"NO APLICADO"}
                            </MenuItem>
                            <MenuItem key={2} value={true}>
                              {"APLICADO"}
                            </MenuItem>
                          </TextField>
                        </Col>

                        <Col>
                          <TextField
                            required
                            id="txtCant"
                            label="Dosis"
                            value={dosis}
                            InputProps={{
                              inputProps: { min: 0, max: 100 },
                              /* endAdornment: <InputAdornment position='end' >MBq</InputAdornment> */
                            }}
                            type="number"
                            onChange={(e) => setDosis(e.target.value)}
                            className="medical-material-form__field"
                            InputLabelProps={{
                              style: { color: "#646777" },
                            }}
                            style={{ marginTop: 5 }}
                          />
                          {/* <TextField
                                                                select
                                                                id="select_unit_measure"
                                                                label="Unidad de Medida"
                                                                //disabled={radioPharmacy == null ? false : true}
                                                                disabled={true}
                                                                value={idUnitMeasurement}
                                                                InputProps={{ inputProps: { min: 0, max: 100 } }}
                                                                type="number"
                                                                onChange={(e) => { setIdUnitMeasurement(e.target.value) }}
                                                                className="medical-material-form__field"
                                                                InputLabelProps={{
                                                                    style: { color: '#646777' },
                                                                    shrink: true
                                                                }}
                                                                style={{ minWidth: '300px', maxWidth: '100%', marginTop: 5 }}
                                                            >
                                                                {unitsMearurement.map((unit) => {
                                                                    return <MenuItem key={unit.codigo} value={unit.codigo}>
                                                                        {unit.nombre}
                                                                    </MenuItem>

                                                                })}
                                                            </TextField> */}
                        </Col>
                      </Row>
                      <Row></Row>
                      <Row>
                        <Col md={6}>
                          <TextField
                            id="txtObservacion"
                            label="Observación"
                            //disabled={radioPharmacy == null ? false : true}
                            value={observacion}
                            onChange={(e) => setObservacion(e.target.value)}
                            className="medical-material-form__field"
                            InputLabelProps={{
                              style: { color: "#646777" },
                            }}
                            style={{
                              minWidth: "300px",
                              maxWidth: "100%",
                              marginTop: 5,
                            }}
                          />
                        </Col>
                      </Row>
                    </>
                  ) : null}
                </div>
              ) : (
                <div className="text-center">
                  <Spinner animation="border" variant="success" />
                </div>
              )}
            </Row>
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 10,
            }}
          >
            <Button
              style={{ marginTop: 10, marginRight: 10 }}
              color="primary"
              disabled={canalizationNeeded.answer !== null ? false : true}
              onClick={() => {
                setAlertColorModal("warning");
                setAlertMessageModal(
                  "Esta seguro que desea aplicar Radiofarmaco a este paciente?"
                );
                setAlerShowModal(true);
              }}
            >
              Aplicar Radiofármaco
            </Button>
          </div>
          <RadiopharmacyDataReactTable reactTableData={reactTableData} />;
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: 10,
            }}
          >
            <Button
              style={{ marginTop: 10, marginRight: 10 }}
              color="primary"
              onClick={() => {
                closeMedicineAdmision(false);
              }}
            >
              Cerrar
            </Button>
          </div>
        </div>
      </Modal>

      <AlertModal
        color={colorAlertModal}
        title={messagAlerteModal}
        modal={showAlertModal}
        onOk={() => {
          onOkModal();
        }}
        toggle={() => setAlerShowModal(false)}
      />
    </div>
  );
};

export default MedicineAdmision;
